export default {
  Export  : "Xuất khẩu",
  Print: "In",
  Save: "Lưu",
  Cancel: "Hủy bỏ",
  Description: "Mô tả",
  Dashboard: "Tổng quan",
  Event: "Sự kiện",
  Product: "Sản phẩm",
  Supplier: "Nhà cung cấp",
  Customer: "Khách hàng",
  SaleEmployee: "Nhân viên bán hàng",
  AddItem: "Thêm mặt hàng",
  Item:'Mặt hàng',
  Category: "Danh mục",
  Order: "Đơn hàng",
  HelpSupport: "Trợ giúp & Hỗ trợ",
  Setting: "Cài đặt",
  AboutMe: "Về chúng tôi",
  Shipper: "Người giao hàng",
  Search: "Tìm kiếm",
  AddProduct: "Thêm sản phẩm",
  AddSupplier: "Thêm nhà cung cấp",
  AddOrder: "Thêm đơn hàng",
  AddCustomer: "Thêm khách hàng",
  AddCategory: "Thêm danh mục",
  AddEmployee: "Thêm nhân viên",
  AddShipper: "Thêm người giao hàng",
  AddEvent: "Thêm sự kiện",
  AddItem: "Thêm mặt hàng",
  DiscountRate: "Chiết khấu",
  AddUser: 'Thêm người dùng',
  AddGroup: 'Thêm nhóm',
  AddPolicy : 'Thêm quyền',
  EditProduct: "Sửa sản phẩm",
  EidtSupplier: "Sửa nhà cung cấp",
  EditCustomer: "Sửa khách hàng",
  EditOrder: "Sửa đơn hàng",
  EditCategory: "Sửa danh mục",
  EditEmployee: "Sửa nhân viên",
  EditEvent: "Sửa sự kiện",
  EditUser: 'Sửa người dùng',
  EditGroup: 'Sửa nhóm người dùng',
  EditShipper: "Sửa người giao hàng",
  EditItem: "Sửa mặt hàng",
  ProductManage: "Hệ thống quản lý sản phẩm",
  UserName: "Tài khoản",
  Password: "Mật khẩu",
  Login: "Đăng nhập",
  ForgotPassword: "Quên mật khẩu",
  Logout: "Đăng xuất",
  HasAccount: "Bạn đã có tài khoản?",
  Register: "Đăng ký",
  userNameInvalid: "Tên đăng nhập không được để trống",
  passwordInvalid: "Mật khẩu không được để trống",
  Sale: "Bán hàng",
  Active: "Hoạt động",
  Inactive: "Ngừng hoạt động",
  HotLineZalo: "Holine (Zalo): 0946210891",
  Add: "Thêm",
  AddMore: "Thêm nhiều hơn",
  MessageResponse: "Error message",
  TestekTitleDashboard: "TESTEK - KIỂM THỬ THỰC CHIẾN",
  ViewDetail: "Xem chi tiết",
  LoginSuccess: "Đăng nhập thành công",
  LoginFail: "Đăng nhập thất bại",
  FeatureUnderDevelop: "Tính năng đang phát triển",
  Vietnamese: "Tiếng Việt",
  English: "Tiếng Anh",
  Language: "Ngôn ngữ",
  TitleProductId: "Mã sản phẩm",
  TitleCategoryId: "Mã danh mục",
  TitleSupplierId: "Mã nhà cung cấp",
  TitleSaleEmployeeId: "Mã nhân viên",
  TitleCustomerId: "Mã khách hàng",
  TitleShipperId: "Mã người giao hàng",
  TitleOrderId: "Mã đơn hàng",
  TitleEventId: "Mã sự kiện",
  TitleItemId: "Mã mặt hàng",
  TitleDetailInfo: "Thông tin chi tiết",
  TitleUserId: 'Mã người dùng',
  TitleGroupId: 'Mã nhóm người dùng',
  Close: "Đóng",
  Save: "Lưu",
  Status: 'Trạng thái',
  Delete: 'Xóa',
  Edit: 'Sửa',
  CategoryInfo: {
    CategoryName: "Tên danh mục",
    CategoryDescription: "Mô tả danh mục",
    Status: "Trạng thái",
  },

  EmployeeInfo: {
    Name: "Tên",
    PhoneNumber: "Số điện thoại",
    Code: "Mã nhân viên",
    DOB: "Ngày sinh",
    Avatar: "Ảnh đại diện",
    Note: "Ghi chú",
    Status: "Trạng thái",
    Group: "Nhóm",
    Email: "Email",
  },

  CustomerInfo: {
    Name: "Tên",
    PhoneNumber: "Số điện thoại",
    Email: "Email",
    Country: "Quốc gia",
    City: "Thành phố",
    Address: "Địa chỉ",
    PostalCode: "Mã bưu điện",
    Status: "Trạng thái",
    Type: "Loại",
    Guest: "Khách hàng hay không",
  },

  SupplierInfo: {
    Address: "Địa chỉ",
    City: "Thành phố",
    ContactName: "Liên lạc",
    Country: "Quốc gia",
    Name: "Tên",
    PhoneNumber: "Số điện thoại",
    PostalCode: "Mã bưu điện",
  },

  OrderInfo: {
    ShippingAddress: "Địa chỉ giao hàng",
    ShippingPhone: "SDT giao hàng",
    InvoiceAddress: "Địa chỉ hóa đơn",
    Quantity: "Số  lượng",
    Total: "Tổng tiền",
    Status: "Trạng thái",
  },

  UserInfo: {
    Code: 'Mã người dùng',
    Name: 'Tên người dùng',
    DoB: 'Ngày sinh',
    Group: 'Nhóm',
    Other: 'Thông tin khác',
    Action: 'Chức năng',
    User: "Người dùng",
    Roles: "Vai trò",
    Email: "Email",
    PhoneNumber: 'Số điện thoại',
    IdentityNumber: 'Số CMND',
    AccountState: 'Trạng thái tài khoản',
  },

  GroupInfo: {
    Code: 'Mã nhóm',
    Name: "Tên nhóm",
    Other: 'Thông tin khác',
    Action: 'Chức năng',
    Description: 'Mô tả',
    Status: 'Trạng thái',
    ResourceName: 'Tên quyền',
    ResourceCode: 'Mã quyền',
  },
  EditSupplier: 'Sửa nhà cung cấp',
  AddCategorySuccess: "Thêm danh mục thành công",
  AddCategoryFail: "Thêm danh mục thất bại",
  AddEmployeeSuccess: "Thêm nhân viên thành công",
  AddEmployeeFail: "Thêm nhân viên thất bại",
  AddCustomerSuccess: "Thêm khách hàng thành công",
  AddCustomerFail: "Thêm khách hàng thất bại",
  AddSupplierSuccess: "Thêm nhà cung cấp thành công",
  AddSupplierFail: "Thêm nhà cung cấp thất bại",
  AddProductSuccess: "Thêm sản phẩm thành công",
  AddProductFail: "Thêm sản phẩm thất bại",
  AddOrderSuccess: "Thêm đơn hàng thành công",
  AddOrderFail: "Thêm đơn hàng thất bại",
  AddShipperSuccess: "Thêm người giao hàng thành công",
  AddShipperFail: "Thêm người giao hàng thất bại",
  AddEventSuccess: "Thêm sự kiện thành công",
  AddEventFail: "Thêm sự kiện thất bại",
  AddItemSuccess: "Thêm mặt hàng thành công",
  AddItemFail: "Thêm mặt hàng thất bại",
  AddUserSuccess: 'Thêm người dùng thành công',
  AddUserFail: 'Thêm người dùng thất bại',
  AddGroupSuccess: 'Thêm nhóm người dùng thành công',
  AddGroupaFail: 'Thêm nhóm người dùng thất bại',
  AddUserToGroupSuccess: 'Thêm người dùng vào nhóm thành công',
  AddUserToGroupFail: 'Thêm người dùng vào nhóm thất bại',

  EditCategorySuccess: "Sửa danh mục thành công",
  EditCategoryFail: "Sửa danh mục thất bại",
  EditEmployeeSuccess: "Sửa nhân viên thành công",
  EditEmployeeFail: "Sửa nhân viên thất bại",
  EditCustomerSuccess: "Sửa khách hàng thành công",
  EditCustomerFail: "Sửa khách hàng thất bại",
  EditSupplierSuccess: "Sửa nhà cung cấp thành công",
  EditSupplierFail: "Sửa nhà cung cấp thất bại",
  EditProductSuccess: "Sửa sản phẩm thành công",
  EditProductFail: "Sửa sản phẩm thất bại",
  EditOrderSuccess: "Sửa đơn hàng thành công",
  EditOrderFail: "Sửa đơn hàng thất bại",
  EditShipperSuccess: "Sửa người giao hàng thành công",
  EditShipperFail: "Sửa người giao hàng thất bại",
  EditEventSuccess: "Sửa sự kiện thành công",
  EditEventFail: "Sửa sự kiện thất bại",
  EditItemSuccess: "Sửa mặt hàng thành công",
  EditItemFail: "Sửa mặt hàng thất bại",
  EditUserSuccess: 'Sửa người dùng thành công',
  EditUserFail: 'Sửa người dùng thất bại',
  EditGroupSuccess: 'Sửa nhóm người dùng thành công',
  EditGroupFail: 'Sửa nhóm người dùng thất bại',


  DeleteProductSuccess: "Xóa sản phẩm thành công",
  DeleteProductFail: "Xóa sản phẩm thất bại",
  DeleteCategorySuccess: "Xóa danh mục thành công",
  DeleteCategoryFail: "Xóa danh mục thất bại",
  DeleteEmployeeSuccess: "Xóa nhân viên thành công",
  DeleteEmployeeFail: "Xóa nhân viên thất bại",
  DeleteCustomerSuccess: "Xóa khách hàng thành công",
  DeleteCustomerFail: "Xóa khách hàng thất bại",
  DeleteSupplierSuccess: "Xóa nhà cung cấp thành công",
  DeleteSupplierFail: "Xóa nhà cung cấp thất bại",
  DeleteOrderSuccess: "Xóa đơn hàng thành công",
  DeleteOrderFail: "Xóa đơn hàng thất bại",
  DeleteShipperSuccess: "Xóa người giao hàng thành công",
  DeleteShipperFail: "Xóa người giao hàng thất bại",
  DeleteEventSuccess: "Xóa sự kiện thành công",
  DeleteEventFail: "Xóa sự kiện thất bại",
  DeleteItemSuccess: "Xóa mặt hàng thành công",
  DeleteItemFail: "Xóa mặt hàng thất bại",
  DeleteUserSuccess: 'Xóa người dùng thành công',
  DeleteUserFail: 'Xóa người dùng thất bại',
  DeleteGroupSuccess: 'Xóa nhóm người dùng thành công',
  DeleteGroupFail: 'Xóa nhóm người dùng thất bại',

  TotalAmount: 'Tổng tiền',
  AddRow: "Thêm dòng",
  Confirm: 'Xác nhận',
  Total: 'Tổng',
  Quantity: 'Số lượng',
  Price: 'Giá',
  SaveRow: 'Lưu dòng',
  DeleteRow: 'Xóa dòng',
  EditRow: 'Sửa dòng',
  OverQuantity: 'Số lượng vượt quá',
  MaxRowItems: 'Số lượng dòng tối đa',
  MinRowItems: "Không xóa dòng đầu tiên",
  Warning: 'Cảnh báo',
  SaveRowBeforeSubmit: 'Vui lòng lưu dòng trước khi thực hiện thao tác này',
  NotRowSave: 'Vui lòng thêm ít nhất 1 dòng trước khi lưu',
  ChangeQuantityOverBeforeSubmit: 'Số lượng trên dòng vượt quá số lượng đang có',
  DeleteProductConfirm: `Bạn có chắc chắn muốn xóa sản phẩm {name} này không?`,
  DeleteCategoryConfirm: `Bạn có chắc chắn muốn xóa danh mục {name} này không?`,
  DeleteEmployeeConfirm: `Bạn có chắc chắn muốn xóa nhân viên {name} này không?`,
  DeleteCustomerConfirm: `Bạn có chắc chắn muốn xóa khách hàng {name} này không?`,
  DeleteSupplierConfirm: `Bạn có chắc chắn muốn xóa nhà cung cấp {name} này không?`,
  DeleteOrderConfirm: `Bạn có chắc chắn muốn xóa đơn hàng {name} này không?`,
  DeleteShipperConfirm: `Bạn có chắc chắn muốn xóa người giao hàng {name} này không?`,
  DeleteUserConfirm: 'Bạn có chắc chắn muốn xóa người dùng {name} này không?',
  DeleteGroupConfirm: 'Bạn có chắc chắn muốn xóa nhóm người dùng {name} này không?',
  ReloadData: 'Nạp dữ liệu',

  QuantityRowOver: 'Số lượng trên dòng vượt quá số lượng đang có',
  AreYouSureDelete: 'Bạn có chắc chắn muốn xóa không?',
  Yes: 'Có',
  No: 'Không',
  User: 'Người dùng',
  Action: 'Chức năng',

  SignInAs: "Đăng nhập với",
  Account1: 'Admin',
  Account2: 'User',
  Account3: "Khách",
  InputForSearch: 'Nhập để tìm kiếm',
  Group: 'Nhóm',

  AddUser: 'Thêm người dùng',
  AddToGroup: 'Thêm vào nhóm',
  SelectGroup: 'Chọn nhóm',
  OrderStatus: 'Trạng thái đơn hàng',
  ClearFilter: 'Xóa bộ lọc',
  AddGroupFail: 'Thêm nhóm thất bại',
  AddGroupSuccess: 'Thêm nhóm thành công',
};
